import Vue from "vue";
import VueRouter from "vue-router";
import { envConfig } from "envConfigPath";
import children from "./children";
import newproducts from "./newcompanyinfo";
import { getSysConfigInfo } from "@/api/home";
Vue.use(VueRouter);

const originalReplace = VueRouter.prototype.replace;
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(e => e);
};
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(e => e);
};
const baseRoutes = [
  {
    path: "/login",
    name: "登录",
    component: () => import("@/views/login/index.vue")
  },
  {
    path: "/forget-password",
    name: "忘记密码",
    component: () => import("@/views/forgetPassword/index.vue")
  },
  {
    path: "/vehicleConfigDetails",
    name: "车辆配置详情",
    component: () => import("@/views/newProducts/pages/vehicleConfigDetails.vue")
  }
  // {
  //   path: "*",
  //   name: "首页",
  //   iCons: "icon-client-menu",
  //   redirect: "/products",
  //   component: () => import("@/views/index.vue"),
  //   children: [...newproducts, ...children]
  // }
];
// 动态添加主路由
export function setupRouter(defaultRoute = "/products") {
  const mainRoute = {
    path: "*",
    name: "首页",
    iCons: "icon-client-menu",
    redirect: defaultRoute,
    component: () => import("@/views/index.vue"),
    children: [...newproducts, ...children]
  };

  router.addRoute(mainRoute);
}

// 在应用启动时调用
export async function initAppRouter() {
  try {
    const config = await getSysConfigInfo(true);
    const defaultRoute = config.version === 1 ? "/new-products" : "/products";
    setupRouter(defaultRoute);
  } catch (error) {
    console.error("初始化路由失败:", error);
    setupRouter(); // 使用默认值
  }
}
const router = new VueRouter({
  mode: "history",
  base: envConfig.routerPrefix,
  routes: baseRoutes
});

router.beforeEach((to, from, next) => {
  // 处理商品详情页的参数格式化
  if (to.name === "商品详情" && to.query?.data) {
    try {
      const data = JSON.parse(decodeURIComponent(to.query.data));
      if (data.hadSet) {
        next();
        return;
      }
      const _data = {
        id: data.id,
        type: data.type,
        property: data.property,
        warehouse: data.warehouse,
        productBatch: data.productBatch,
        hadSet: true
      };

      if (data.showExchange) {
        _data.showExchange = true;
      }

      // 创建新的路由对象
      const newRoute = {
        path: to.path,
        query: {
          data: encodeURIComponent(JSON.stringify(_data))
        }
      };

      next(newRoute);
      return; // 重要：停止后续执行
    } catch (error) {
      console.error("解析路由参数失败:", error);
      // 参数错误时重定向到安全页面
      next("/products");
      return;
    }
  }

  next();
});

export default router;
